import { routeType as routeTypeEnum } from '@/enums/routeType'

function getBackgroundJobResultUrl (status, data) {
  const { routeType } = data || {}
  if (!routeType || status === 0) return null

  switch (routeType) {
    case routeTypeEnum.enum.ReportSubmissionGroupDetail:
      return data && typeof data.reportGroupSubmissionId === 'number'
        ? `${data.forecasting ? '/forecast-report-submission-groups/' : '/report-submission-groups/'}${data.reportGroupSubmissionId}/report-submissions`
        : '#'
    case routeTypeEnum.enum.OutputReportGroupDetail:
      return data && typeof data.outputReportGroupId === 'number'
        ? `/output-report-groups/${data.outputReportGroupId}/output-reports`
        : '#'
    case routeTypeEnum.enum.ReportSubmissionSubmitDetail:
      return data && typeof data.reportGroupSubmissionId === 'number'
        ? `/report-submission-groups/${data.reportGroupSubmissionId}/report-submissions/xml-signing`
        : '#'
    default: return null
  }
}

export {
  getBackgroundJobResultUrl
}



// WEBPACK FOOTER //
// ./src/components/backgroundJobs/backgroundJobUrl.js